import React from 'react';
import { ProductAttribute } from '../types';
import './ProductAttrs.css';

interface Props {
  attributes?: ProductAttribute[];
  /** compact — одна строка с разделителями, full — столбик */
  mode?: 'compact' | 'full';
}

const ProductAttrs: React.FC<Props> = ({ attributes, mode = 'compact' }) => {
  if (!attributes || attributes.length === 0) return null;

  if (mode === 'full') {
    return (
      <div className="pa-full">
        {attributes.map((a, i) => (
          <span key={i} className="pa-chip">
            <span className="pa-key">{a.key}:</span> {a.value}
          </span>
        ))}
      </div>
    );
  }

  // compact — горизонтальные чипы в одну строку
  return (
    <div className="pa-compact">
      {attributes.map((a, i) => (
        <span key={i} className="pa-chip">
          <span className="pa-key">{a.key}:</span> {a.value}
        </span>
      ))}
    </div>
  );
};

export default ProductAttrs;
